import styled from 'styled-components';
import { Tooltip } from '../../Tooltip';
import { theme } from '../../../theme';

const alignMap = {
  top: 'flex-start',
  center: 'center',
};

export const RootLayout = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: ${theme.sizes.base};
  }
`;

export interface InputLayoutProps {
  align: 'top' | 'center';
}

export const InputLayout = styled.div<InputLayoutProps>`
  align-self: stretch;
  display: flex;
  align-items: ${(props) => alignMap[props.align]};
`;

export const AccessoryLayout = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
`;

export const TextLayout = styled.div`
  flex: 1;

  & > * + * {
    margin-top: ${theme.sizes.sm};
  }
`;

export const Wrapper = styled.label<{ disabled: boolean }>`
  box-sizing: border-box;

  &:hover {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }
`;

export const BorderedWrapper = styled(Wrapper)`
  border: 2px solid ${theme.colors.neutral.grey.dark};
  border-radius: ${theme.radius.md};
  padding: ${theme.sizes.base} 0.75rem;

  &:hover {
    border-color: ${theme.colors.secondary.blue.base};
  }
`;

export const BlockTooltip = styled(Tooltip)`
  /* Tooltip uses inline-block containers which add more height when
     the child component is an inline element (e.g. Glyph or an SVG),
     so we need to set to block to preserve the height and fix alignment. */
  display: block;
  &-hoverable {
    display: block;
  }
`;
